import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBell: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconBell"><Path d="M11.9998 2C7.81727 2 4.24187 5.1556 3.79996 9.31476L2.99271 15.1579C2.78514 16.6603 3.95246 18 5.46919 18H18.5309C20.0476 18 21.2149 16.6603 21.0073 15.1578L20.2 9.31477C19.7581 5.1556 16.1824 2 11.9998 2Z" fill="currentColor"/><Path d="M16.2438 19H7.75591C8.37366 20.7478 10.0405 22 11.9998 22C13.9592 22 15.626 20.7478 16.2438 19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBell;
